import { styled } from '@mui/material';

const PREFIX = 'ActionDialogPicker';

export const actionDialogPickerClasses = {
  textSuccess: `${PREFIX}-textSuccess`,
  textError: `${PREFIX}-textError`,
  mimicLink: `${PREFIX}-mimicLink`,
};

export const ActionDialogPickerRoot = styled('div')(({ theme }) => ({
  [`&.${actionDialogPickerClasses.textSuccess}`]: {
    color: theme.palette.secondary[900],
  },

  [`& .${actionDialogPickerClasses.textError}`]: {
    color: theme.palette.error.main,
  },

  [`& .${actionDialogPickerClasses.mimicLink}`]: {
    cursor: 'pointer',
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
}));